import Analytics from '../analytics'

const EVENT_TITLE = 'Affiliate link copied'

type EventData = {
  affiliateId: number
  saleId: number
  publisherId: number
}

const affiliateLinkCopied = (params: EventData) => {
  Analytics().track(EVENT_TITLE, params)
}

export default affiliateLinkCopied
